const state = {
    activeSlide: 1,
    toggled: true
}

const mutations = {
    setActiveSlide(state, slide) {
        state.activeSlide = slide
    },
    setToggle(state) {
        state.toggled = !state.toggled
    }
}

const actions = {
    changeSlide({ commit }, slide) {
        commit('setActiveSlide', slide)
        commit('setToggle')
    }
}

const getters = {
    activeSlide(state) {
        return state.activeSlide
    },
    toggled(state) {
        return state.toggled
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}